import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment';

//components
import withPermissions from '~/hoc/withPermissions';
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import Checkbox from '../../../components/CustomCheckbox/CustomCheckbox';
import ProjectTaskImport from './ProjectTaskImport.js';
import GenericSearch from "../../../components/GenericForm/IntegrationFilter";

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';

//assets
import CloseIcon from "~/assets/img/modal-close-icon.svg";
import ActivateUser from '../../../assets/img/ActivateUser.svg'
import LoadingSpinner from '../../../elements/LoadingSpinner';

//utils
import { payrollIntegrationOptions } from '../../../utils/constants';

const page_size = 10;
class ProjectImport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showImportModal: true,
            projectToSync: [],
            projectAddIds: [],
            loading: false,
            showResponseText: '',
            nextToken: null,
            previousToken: null,
            pageInfo: null,
            showTaskSyncModal: false,
            projectWithTasks: [],
            projectMapping: [],
            currentFilters: null,
            visibleProjectCount: null,
            isCountLoading: false
        }
    }

    componentDidMount() {
        const params = {
            first: page_size,
        }
        this.loadData(params);
    }

    selectAllNonSyncedProjects = (projectList) => {
        const nonSyncedProjects = projectList.filter(project => !project.isSynced);
        this.setState({ projectAddIds: nonSyncedProjects })
    }

    async loadData(params) {
        const { projectStore } = this.props
        this.setState({ loading: true })
        const { list, nextCursorToken, previousCursorToken, pageInfo } = await projectStore.getAllProjectFromIntegration(params)
        this.setState({ projectToSync: list, nextToken: nextCursorToken, previousToken: previousCursorToken, pageInfo: pageInfo, loading: false }, () => {
            this.selectAllNonSyncedProjects(list);
        })
    }

    async handleTaskSync(res2) {
        const { commonStore, t } = this.props;
        const { projectAddIds } = this.state;
        const projects = res2.projectMapping.map(({ projectId, integrationDbId, flexiFieldCode2DbId }) => ({ projectId, projectIntId: integrationDbId ?? null, flexiFieldCode2DbId: flexiFieldCode2DbId ?? null }));
        const res = await this.props.taskStore.saveTaskInBulkFromIntegration({ projects });
        if (res.message) {
            commonStore.addNotification(`${t(res.message)}`, null, 'success');
        }
        this.setState({ loading: false, projectWithTasks: projectAddIds, showImportModal: false, projectMapping: res2.projectMapping })
    }

    importProjectFromIntegration = async () => {
        const { projectStore, commonStore, t } = this.props;
        const { projectAddIds } = this.state;
        const product = this.props.commonStore.config?.integration_details?.product;
        if (commonStore.config?.biztype?.data?.allow_multiple_branches) {
            if (commonStore.config?.client?.max_branches_allowed <= projectStore.currentList.total) {
                return commonStore.addNotification(t('You have exceeded project/branch limit, Please Contact Time & Control'), null, 'error');
            }
        }
        const str = t(`Do You want to Import selected Project into TimeAndControl`);
        confirmAlert({
            title: t('Confirm to Import'),
            message: str,
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        this.setState({ loading: true })
                        return projectStore.saveProjectFromIntegration({ projects: projectAddIds, product: this.props.commonStore.config?.integration_details?.product }).then((res2) => {
                            commonStore.addNotification(`${t(res2.message)} ${commonStore.config?.integration_details?.product}`, null, 'success');
                            projectStore.resetLastListLoadTime();
                            if (product === payrollIntegrationOptions.XLEDGER) {
                                confirmAlert({
                                    title: t('Task Found'),
                                    message: res2.hasTask ? t("Tasks were found linked to the projects you're importing payroll system. Would you like to download these tasks as well?") : t("Would you like to download default tasks for selected projects ?"),
                                    buttons: [
                                        {
                                            label: t('yes'),
                                            onClick: async () => {
                                                await this.handleTaskSync(res2);
                                            }
                                        },
                                        {
                                            label: t('No'),
                                            onClick: () => {
                                                this.setState({ loading: false, showResponseText: t("Please assign the projects to members so that members can start recording work hours, etc., and don't forget to include the project address by clicking on the 'Edit' button") })
                                            }
                                        }
                                    ]
                                })
                            } else {
                                this.setState({ loading: false, showResponseText: t("Please assign the projects to members so that members can start recording work hours, etc., and don't forget to include the project address by clicking on the 'Edit' button") })
                            }
                            return res2;
                        }).catch(error => {
                            console.error({ error });
                            commonStore.addNotification(`${t(error.message || 'Something went wrong')}`, null, 'error');
                            this.setState({ loading: false })
                        });;
                    },
                },
                {
                    label: t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    handleFilterChange = async (filters) => {
        const params = {
            filter: filters,
            first: page_size,
        }
        this.setState({ currentFilters: filters, visibleProjectCount: null }, () => this.loadData(params));
    }

    handleCheckbox = (ele, e) => {
        const product = this.props.commonStore.config?.integration_details?.product;
        if (e) {
            this.setState({ projectAddIds: [ele, ...this.state.projectAddIds] })
        }
        else {
            const updateIds = this.state.projectAddIds.filter(item => product === payrollIntegrationOptions.TRIPLETEX
                ? item.project.id !== ele.project.id
                : product === payrollIntegrationOptions.XLEDGER
                    ? item.project.node.dbId !== ele.project.node.dbId
                    : true
            );
            this.setState({ projectAddIds: updateIds })
        }
    }

    handlePageChange = (isNext) => {
        const { commonStore, t } = this.props;
        const { previousToken, nextToken } = this.state;
        if ((!nextToken && isNext) || (!previousToken && !isNext))
            return commonStore.addNotification(t("No data to display"), null, 'warning');
        const params = {
            filter: this.state.currentFilters,
        }
        if (isNext) {
            params.first = page_size;
            params.after = nextToken;
        }
        else {
            params.last = page_size;
            params.before = previousToken;
        }
        this.setState({ loading: true, visibleProjectCount: null }, () => this.loadData(params));
    }

    handleTaskImportModal = (value) => {
        this.setState({ showTaskSyncModal: value })
        this.props.projectStore.resetLastListLoadTime();
    }

    isProjectSelected = (project) => {
        const product = this.props.commonStore.config?.integration_details?.product;
        return this.state.projectAddIds.some(item => product === payrollIntegrationOptions.TRIPLETEX ?
            item.project.id === project.project.id : product === payrollIntegrationOptions.XLEDGER ? item.project.node.dbId === project.project.node.dbId : false);
    }

    handleProjectCount = async () => {
        const { currentFilters } = this.state;
        const { commonStore, projectStore, t } = this.props;
        if (!currentFilters || !currentFilters.createdAt_gte || !currentFilters.createdAt_lte) {
            return commonStore.addNotification(t('Please select From Date and To Date to see count of projects'), null, 'warning');
        }

        this.setState({ isHoursLoading: true });
        try {
            const { count } = await projectStore.getIntegrationProjectsCount({ filter: currentFilters });

            this.setState({
                visibleProjectCount: count
            });
        } catch (error) {
            console.error(error);
            commonStore.addNotification(t('Failed to fetch project hours'), null, 'error');
        } finally {
            this.setState({ isHoursLoading: false });
        }
    }

    render() {
        const { t, handleImportModal } = this.props;
        const { loading, showImportModal, showResponseText, pageInfo } = this.state
        const product = this.props.commonStore.config?.integration_details?.product;

        return (
            <div>
                <Modal
                    size="lg"
                    className="modal fade"
                    show={showImportModal}
                    onHide={() => handleImportModal(!this.state.showImportModal)}
                >
                    <Modal.Header>
                        <Modal.Title>{t('Import Projects from')} {this.props.commonStore.config?.integration_details?.product}</Modal.Title>
                        <div className='modal-header__revised__closebtn' onClick={() => handleImportModal(!this.state.showImportModal)}>
                            <img
                                src={CloseIcon}
                                className="cursor-pointer"
                                alt='close_button'
                            />
                        </div>
                    </Modal.Header>
                    <Modal.Body className='mb-2'>
                        {product === payrollIntegrationOptions.XLEDGER && <GenericSearch
                            entity="projects"
                            onChange={this.handleFilterChange}
                            fromDateTooltip="Filter projects that started after from date"
                            toDateTooltip="Filter projects that started before to date"
                            displayName="Projects"
                            searchTooltip="Search or filter projects by their name or code. If a project is not in the list, you can still find it by entering its project code and clicking the 'Search' option in the dropdown."
                        />}
                        {loading ?
                            <LoadingSpinner />
                            :
                            <Fragment>
                                {showResponseText === '' ?
                                    <>
                                        <div className='d-flex justify-content-space-between align-items-center mb-2 w-100'>
                                            <div>
                                                <span className='fw-bold font-size-15'>
                                                    {t('Select a project to import')}
                                                </span>
                                                {product === payrollIntegrationOptions.XLEDGER && (
                                                    <span className="ms-2">
                                                        {this.state.isHoursLoading ? (
                                                            <i className="fa fa-spinner fa-spin text-muted ms-2"></i>
                                                        ) : this.state.visibleProjectCount !== null ? (
                                                            <span className="fw-bold ms-2 color-2550AC">{this.state.visibleProjectCount}</span>
                                                        ) : (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                overlay={
                                                                    <Tooltip id="view-hours-tooltip">
                                                                        {t('Project count')}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <i
                                                                    className="fa fa-eye ms-2 cursor-pointer text-secondary"
                                                                    style={{ fontSize: '0.9em' }}
                                                                    onClick={this.handleProjectCount}
                                                                    role="button"
                                                                    aria-hidden="true"
                                                                />
                                                            </OverlayTrigger>
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                            {this.props.commonStore.config?.integration_details?.product === payrollIntegrationOptions.XLEDGER && <div>
                                                <Button disabled={!pageInfo?.hasPreviousPage}
                                                    onClick={() => this.handlePageChange(false)}
                                                >
                                                    <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                                    {t('Prev')}
                                                </Button>
                                                <Button fill wd
                                                    disabled={!pageInfo?.hasNextPage}
                                                    style={{ margin: "0 1em" }}
                                                    onClick={() => this.handlePageChange(true)}
                                                >
                                                    {t('Next')}
                                                    <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                                                </Button>
                                            </div>
                                            }
                                        </div>
                                        <div className='projectMemberForm'>
                                            <Table className='w-100 ' style={{ minHeight: '10vh' }}>
                                                <thead>
                                                    <tr className='w-100'>
                                                        <th width={'50%'} style={{ textAlign: 'left' }}>{t('Project')}</th>
                                                        <th width={'50%'}>{t('Synced')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.projectToSync.length === 0 && <tr><td colSpan={2} className='text-center'>{t('No Data Found')}</td></tr>}
                                                    {this.state.projectToSync.map((ele, idx) => (
                                                        <tr key={idx} className='text-capitalize mt-1'>
                                                            <td width={'50%'} className='' style={{ textAlign: 'left' }}><div className=''>{ele.project.name || ele.project.node.description}</div></td>
                                                            <td width={'50%'} className='timelog_array_details'>
                                                                {ele.isSynced ?
                                                                    <img src={ActivateUser} alt='tick' title='Already Synced' />
                                                                    :
                                                                    <Checkbox
                                                                        // isChecked={ele.isSynced || ele?.nowSynced}
                                                                        isChecked={this.isProjectSelected(ele)}
                                                                        onChange={checked => this.handleCheckbox(ele, checked)}
                                                                        disabled={ele.isSynced}
                                                                        wrapperClassName={'bulk-shift-chekbox-style'}
                                                                    />
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                        {this.props.commonStore.config?.integration_details?.product !== payrollIntegrationOptions.XLEDGER && <div>
                                            <p className='font-size-12 lh-1 color-2550AC'><span className='fw-bold me-2'>{t('Note')}:</span>{t('All project-related tasks are automatically imported with the projects. To avoid conflicts, please refrain from creating tasks in payroll after the project is imported in TimeAndControl. Instead, create tasks within TimeAndControl and sync them with payroll')}.</p>
                                        </div>}
                                    </>
                                    :
                                    <>
                                        <div className='d-flex justify-content-center align-items-center flex-column'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="60px" height="60px" viewBox="0 0 1024 1024"><path fill="#2550AC" d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"></path></svg>
                                            <div className='w-75'>{showResponseText}</div>
                                        </div>
                                    </>
                                }
                            </Fragment>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {showResponseText === '' ?
                            <>
                                <Button fill wd
                                    onClick={this.importProjectFromIntegration}
                                    disabled={!this.state.projectAddIds.length}
                                >
                                    {t('Import Selected Projects')}
                                </Button>
                                <Button wd
                                    onClick={() => handleImportModal(!this.state.showImportModal)}
                                >
                                    {t('Cancel')}
                                </Button>
                            </>
                            :
                            <>
                                <Button wd
                                    onClick={() => handleImportModal(!this.state.showImportModal)}
                                >
                                    {t('OK')}
                                </Button>
                            </>
                        }
                    </Modal.Footer>
                </Modal>
                {
                    this.state.showTaskSyncModal && <ProjectTaskImport
                        handleTaskImportModal={this.handleTaskImportModal}
                        projects={this.state.projectWithTasks}
                        projectMapping={this.state.projectMapping}
                    />
                }
            </div>
        );
    }
}
export default inject(
    'projectStore',
    'userStore',
    'commonStore',
    'taskStore'
)(applicationRouter(withPermissions(withLocalization(observer(ProjectImport)))));
